import { ColumnMode } from '@swimlane/ngx-datatable';
import { merge } from 'lodash-es';

/**
 * Common configuration class for managing ngx-datatable default properties.
 * Individual properties can be customized easily by providing a TableConfig-like
 * object to the constructor with the properties that you want to customize.
 *
 * For example, if you wanted all the defaults but needed to change only the `limit` property:
```
const tableConfig = new TableConfig({
  limit: 10
});
```
 */
export class TableConfig {
  columnMode?: ColumnMode = ColumnMode.force;
  flexColumnMode?: ColumnMode = ColumnMode.flex;
  headerHeight? = 50;
  largeHeaderHeight? = 70;
  footerHeight?: number | string = '100%';
  rowHeight?: number | string = 'auto';
  limit? = 5;
  allowColumnReordering? = false;
  allowColumnResizing? = false;
  scrollbarH? = false;
  pageNumber? = 0;
  totalElements? = 0;
  virtualization? = false;

  constructor(tableConfig?: TableConfig) {
    if (tableConfig) {
      merge(this, tableConfig);
    }
  }
}
